// extracted by mini-css-extract-plugin
export default {"container":"xE-z","dimension":"yE-z","dimensionLabels":"zE-z"};